// src/pages/NotFound.js
import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const NotFound = () => {
    const { t } = useTranslation();

    return (
        <Container className="text-center py-5">
            <Row className="justify-content-center">
                <Col md={6}>
                    <h1 className="display-1">404</h1>
                    <h2 className="mb-4">Страница не найдена</h2>
                    <p className="mb-4">
                        Страница, которую вы ищете, не существует или была перемещена.
                    </p>
                    <Link to="/">
                        <Button variant="primary">{t('common.back')}</Button>
                    </Link>
                </Col>
            </Row>
        </Container>
    );
};

export default NotFound;